import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles()(function (theme) { return ({ textField: { border: "none", width: "100%", height: "100%", outlineColor: theme.palette.primary.main } }); });
var textStyle = { paddingLeft: 16, paddingRight: 5 };
var rightTextStyle = Object.assign({}, textStyle, { textAlign: "right" });
export function TextCell(props) { var styles = useStyles().classes; var _a = useState(props.value), value = _a[0], setValue = _a[1]; var _b = useState(null), ref = _b[0], setRef = _b[1]; var changeCalled = false; useEffect(function () { if (ref === null)
    return; ref.focus(); ref.select(); }, [ref]); return /*#__PURE__*/ _jsx("input", { ref: setRef, type: "text", defaultValue: props.value, onChange: function (e) { return setValue(e.target.value); }, onKeyDown: function (e) { if (e.key === "Enter") {
        changeCalled = true;
        props.onChange(value);
    } if (e.key === "Tab") {
        changeCalled = true;
        e.preventDefault();
        props.onChange(value, { tab: e.shiftKey ? -1 : 1 });
    } }, onBlur: function () { if (changeCalled)
        return; props.onChange(value); }, style: props.align === "right" ? rightTextStyle : textStyle, className: styles.textField }); }
